import Accordion from "../lib/accordion.js";
function init() {
    [...document.querySelectorAll("[data-accordion]")].map((item) => new Accordion(item).run());
    [...document.querySelectorAll("[data-accordion-hover]")].map((item) => new Accordion(item, {event: 'hover'}).run());
}


document.addEventListener("DOMContentLoaded", init);